var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteclubPublicGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inviteclub_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.362,
    height: 25.014,
    viewBox: "0 0 186.362 25.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M0,24.123V1H5.6V24.123Z",
    transform: "translate(0 0.434)",
    fill: "#0E1D31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M19.9,21.99V12.535c0-2.106-.8-3.582-3.095-3.582a3.782,3.782,0,0,0-3.682,4.026V21.99H7.87V6.3h4.4l.8,1.791A6.762,6.762,0,0,1,17.985,5.93c4.026,0,7.163,1.791,7.163,6.261v9.8Z",
    transform: "translate(3.405 2.566)",
    fill: "#0E1D31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M29.621,21.878C27,16.62,24.392,11.419,21.67,6.19h5.989c1.691,3.682,3.467,7.364,5.229,11,1.791-3.639,3.467-7.321,5.229-11h3.811c-2.865,5.158-5.6,10.387-8.252,15.645Z",
    transform: "translate(9.376 2.678)",
    fill: "#0E1D31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M40.585,6.113A2.708,2.708,0,0,1,37.72,3.505a2.865,2.865,0,1,1,5.731,0,2.693,2.693,0,0,1-2.865,2.607Zm-2.55,18.166.086-16.06h5.3v16.06Z",
    transform: "translate(16.32 0.277)",
    fill: "#0E1D31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M55.749,23.1a13.381,13.381,0,0,1-3.811.659c-2.679,0-5.329-1.519-5.329-4.513v-8.84H44.23V7.618h2.378v-3.3L51.895,2.89V7.618h3.682v2.865H51.895v8.18c0,1.06,0,2.607,1.433,2.607a18.725,18.725,0,0,0,2.407-.3Z",
    transform: "translate(19.137 1.25)",
    fill: "#0E1D31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M70.173,20.293A11.776,11.776,0,0,1,63.2,22.427c-4.885,0-9.456-2.722-9.456-8.123,0-5.129,4.083-8.424,8.968-8.424s8.4,3.41,8.4,8.868H59.2a4.542,4.542,0,0,0,5.029,4.814,8.6,8.6,0,0,0,6.433-3.138Zm-3.925-8.4a3.152,3.152,0,0,0-3.223-3.338A3.61,3.61,0,0,0,59.442,11.9Z",
    transform: "translate(23.251 2.545)",
    fill: "#0E1D31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M71.033,18.9A2.593,2.593,0,1,1,73.626,16.3,2.593,2.593,0,0,1,71.033,18.9Z",
    transform: "translate(29.611 5.932)",
    fill: "#0E1D31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M97.369,22.837a23.352,23.352,0,0,1-9.011,1.834c-6.877,0-14.1-4.3-14.1-11.834S81.051.7,88.014.7A17.693,17.693,0,0,1,98.572,3.854l-1.934,4.1a8.84,8.84,0,0,0-8.08-4.3c-5.057,0-8.109,4.054-8.109,9.183a8.668,8.668,0,0,0,8.725,9.011,13.911,13.911,0,0,0,9.183-4.126Z",
    transform: "translate(32.13 0.301)",
    fill: "#0E1D31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M94.22,24.556,94.263,0H99.55V24.556Z",
    transform: "translate(40.766)",
    fill: "#0E1D31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M114.583,21.878l-.731-2.034a6.82,6.82,0,0,1-5.229,2.45c-3.911,0-7.163-1.834-7.163-6.16V6.19h5.3v9.6c0,2.092.788,3.51,3.095,3.51a3.725,3.725,0,0,0,3.639-3.954V6.19h5.33V21.949Z",
    transform: "translate(43.897 2.678)",
    fill: "#0E1D31"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M117,24.513V0h5.272V10.415a8.037,8.037,0,0,1,4.986-1.991c4.871,0,8.481,3.166,8.481,8.18a8.224,8.224,0,0,1-8.6,8.367,8.911,8.911,0,0,1-6.117-2.35c-.688.559-1.275,1.275-1.92,1.891ZM130.209,16.6c0-2.464-1.06-5.287-3.925-5.287s-4.183,2.751-4.183,5.329.989,5.63,4.183,5.63,3.954-3.223,3.954-5.673Z",
    transform: "translate(50.621)",
    fill: "#0E1D31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteclubPublicGold);
export default __webpack_public_path__ + "static/media/inviteclub_public_gold.aa8295ceae99800e5dbd8ef513da4bfd.svg";
export { ForwardRef as ReactComponent };